// How an instant reads, in one place.
//
// The server sends ISO-8601 strings and does no formatting at all (D6): the app
// owns how a date looks, and a backend that pre-formatted would be a backend
// that has to ship to change a label. So the formatting lives here — one module
// rather than one call per screen, so two pages cannot show the same timestamp
// two different ways.
//
// The browser's own locale decides, which is the right authority for this: a
// customer in Aberdeen and one in Houston should each see their own convention,
// and neither of them should see ours.
//
// A .ts file rather than a .tsx one because the repo lints with
// `react-refresh/only-export-components`, and these are not components.

/** An instant as a person reads it, or a dash where there is none. */
export function when(instant: string | null): string {
  if (!instant) {
    return '—';
  }
  return new Date(instant).toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
}

/** The same, without the time of day, for things counted in days. */
export function onDay(instant: string | null): string {
  if (!instant) {
    return '—';
  }
  return new Date(instant).toLocaleDateString(undefined, { dateStyle: 'medium' });
}
